module.exports = __webpack_public_path__ + "img/49.2e9f0fb0.jpg";